import InsightsGenericFeedbackCard from 'components/InsightsGenericFeedbackCard/InsightsGenericFeedbackCard'

export default InsightsGenericFeedbackCard
